import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiGetRequest } from '../../Helpers/Requests';
import endpoints from '../../Helpers/Endpoints';

const CookieContext = createContext(undefined);

export function CookieProvider({ children }) {
    const [profileId, setProfileId] = useState(null);
    const [isValid, setIsValid] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const checkCookie = async () => {
        try {
            const response = await apiGetRequest(endpoints.verifyJwt);
            console.log('Cookie verification response:', response);

            if (response?.data?.userId) {
                setProfileId(response.data.userId);
                setIsValid(true);
                setError(null);
            } else {
                console.log('Cookie validation failed');
                setError('Cookie validation failed');
                clearCookie();
            }
        } catch (error) {
            console.error('Cookie validation error:', error);
            setError(error?.response?.data?.message || error.message);
            clearCookie();
        } finally {
            setIsLoading(false);
        }
    };

    const clearCookie = () => {
        // Clear client-side Cookie state
        setProfileId(null);
        setIsValid(false);
    };

    useEffect(() => {
        checkCookie();
    }, []);

    return (
        <CookieContext.Provider value={{
            profileId,
            isValid,
            refreshCookie: checkCookie,
            clearCookie,
            error,
            isLoading
        }}>
            {children}
        </CookieContext.Provider>
    );
}

export function useCookie() {
    const context = useContext(CookieContext);
    if (context === undefined) {
        throw new Error('useCookie must be used within a CookieProvider');
    }
    return context;
}